import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import HighRiskIcon from "./HighRiskIcon";
import LowRiskIcon from "./LowRiskIcon";
import MedRiskIcon from "./MedRiskIcon";
import { DASHBOARD_PROJECT_RISK, GET_DASHBOARD_PROJECT_RISK_DATA } from "../../../../utils/services/apiPath";
import { getApi } from "../../../../utils/services";
import { errorToast } from "../../../../utils/toastHelper";
import GenericModal from "../../../Components/Modals/GenericModal";
import ProjectDocumentationRisKTable from "../ProjectDocumentationRisKTable";
import PrevailingWageRisk from "../PrevailingWageRisk";
import PartnerRisk from "../PartnerRisk";
import JourneyApprenticeRisk from "../JourneyApprenticeRisk";
import { Skeleton } from "@mui/material";
import { dummyData } from "./DummyData";
import EmptyStateOverlay from "../EmptyStateOverlay/EmptyStateOverlay";

const iconObj = {
  high: <HighRiskIcon />,
  medium: <MedRiskIcon />,
  low: <LowRiskIcon />
};

const ProjectRiskItem = ({ title, value, onClick }) => {
  return (
    // Temporary: remove the title check once we fix the JtoA counts
    <div className="djr-risk-card" onClick={() => onClick(title)} style={{ cursor:"pointer" }}>
      <div className="djr-risk-card-title-wrapper">
        <div className="djr-risk-card-title">{title}</div>
      </div>
      <div className="djr-risk-card-icon">{iconObj[value]}</div>
    </div>
  );
};

ProjectRiskItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOf(["high", "medium", "low"]).isRequired,
  onClick: PropTypes.func
};

export default function ProjectRisk({ selectedProjectsQuery, startLoading, stopLoading }) {
  const [projectRiskData, setProjectRiskData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentModalTitle, setCurrentModalTitle] = useState("");

  const handleItemClick = title => {    
      setCurrentModalTitle(title);
      setIsModalOpen(true);    
  };

  const getModalContent = () => {
    switch (currentModalTitle) {
      case "Project Documentation Risk":
        return <ProjectDocumentationRisKTable selectedProjectsQuery={selectedProjectsQuery} />;
      case "Prevailing Wage Risk":
        return <PrevailingWageRisk selectedProjectsQuery={selectedProjectsQuery} />;
      case "Partner Risk":
        return <PartnerRisk selectedProjectsQuery={selectedProjectsQuery} />;
      case "Journey to Apprentice Risk":
        return <JourneyApprenticeRisk selectedProjectsQuery={selectedProjectsQuery} />;
      default:
        return <p>General Information</p>;
    }
  };

  const fetchProjectRiskData = async () => {
    startLoading('projectRisk');
    try {
      const data = await getApi(`${DASHBOARD_PROJECT_RISK}?projectIds=${selectedProjectsQuery}`);
      const mappedData = data.map(item => ({
        title: item.projectRiskTitle,
        value: item.projectRating?.toLowerCase()
      }));
      setProjectRiskData(mappedData);
      setIsLoading(false);
    } catch (error) {
      if (error) errorToast(error);
    } finally {
      stopLoading('projectRisk');
    }
  };

  useEffect(() => {
    fetchProjectRiskData();
  }, [selectedProjectsQuery]);

  const hasData = projectRiskData?.length > 0;
  const dataToShow = !hasData ? dummyData : projectRiskData;

  return (
    <div className="djr-Wrapper project-rise-wrapper">
      <div className="djr-header with-dropdown">
        <div className="djr-header-title-wrapper">
          <div className="djr-header-title">Project Risk</div>
        </div>
      </div>
      <div className="djr-risk">
        {!isLoading ?
          (
            <div style={{ position: 'relative', height: '100%', padding: '16px 16px 25px', display: 'flex', flexWrap: 'wrap' }}>
              {dataToShow?.map((risk, index) => (
                <ProjectRiskItem key={Number(index)} title={risk.title} value={risk.value} onClick={handleItemClick} />
              ))}
              {!hasData && <EmptyStateOverlay message="Not enough data available to display Project Risk" />}
            </div>
          )
          : <Skeleton variant="rectangular" width={"100%"} height={400} />
        }
      </div>
      <GenericModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        modalTitle={currentModalTitle}
      >
        {getModalContent()}
      </GenericModal>
    </div>
  );
}
